import cheader from '@/components/header/index.vue'
import caside from '@/components/aside/index.vue'

export default {
  name: 'user_good',
  data() {
    return {
      search: {
        name: ''
      },
      search2: {
        name: '',
        status: ''
      },
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '已对码'
      }, {
        value: '0',
        label: '未对码'
      }, {
        value: '2',
        label: '已申请'
      },],
      value: '',
      title:"",
      unitID: 0,
      page: 1,
      page2: 1,
      selectedGoods: [],
      detailinfo: [],
      goods: [],
      goods2: [],
      total: 0,
      total2: 0,
      curpage: 1,
      curpage2: 1,
      cates: [],
      brands: [],
      presclass: [],
       // 部门树选项
      deptOptions: undefined,
      editFormVisiable: false,
      detailFormVisiable: false,
      codeFormVisiable: false,
      isClick:false,
      form: {
        pwd:"123456",
      },
      //性别
      sexOptions:[{
        dictLabel:"男",
        dictValue:1
      },{
        dictLabel:"女",
        dictValue:2
      }],
      statusOptions:[],
      roleOptions:[],
      rows:{},
      open:false,
      formPwd:{},
      pwdOpen:false,
      nowInfoId:"",
      setPwdTitle:"",
      nowData:{},
      rulePwd:{
        pwd: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ]
      },
      rules: {
        name: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ],
        roleIds: [
          { required: true, message: "角色不能为空"}
        ],
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" }
        ],
        loginName: [
          { required: true, message: "登录名不能为空", trigger: "blur" }
        ],
        pwd: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ],
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    cheader,
    caside
  },
  created() {
    this.index(1)
    this.cateIndex()
    this.brandIndex()
    this.presclassIndex()
  },
  methods: {
    addUser(){
        this.title = "新增用户"
        this.open = true
        this.form = {
          name: '',
          roleIds: "",
          mobile: '',
          email: '',
          loginName: '',
          pwd: '123456'
        };
        this.isClick = false
        this.nowInfoId = ""
        this.findRole()
        this.$nextTick(e =>{
          this.$refs['form'].resetFields()
        })
    },
    
    submitPwdForm(){
      this.$refs["formPwd"].validate(valid => {
        if (valid) {
          this.formPwd.userId = this.user.id;
          this.formPwd.comId = this.user.customerId
          this.formPwd.salesmanId = this.nowData.salesmanId
          this.formPwd.loginName = this.nowData.loginName
          this.$http.post('/api/ucenter/pur/staff/reset',this.formPwd).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "修改成功",
                type: 'success'
              });
              this.pwdOpen = false
              this.index(this.page)
            } else {
              this.$message.warning(res.data.message)
            }
          })
        }
      })
    },
    checkName(){
      var flag = true
      var params = {
        loginName:this.form.loginName,
        userId: this.user.id,
        comId:this.user.customerId,
      }
      this.$http.get('/api/ucenter/pur/staff/verify',{params:params}).then((res) => {
        if (res.data.success) {
          flag = true
        } else {
          flag = false
          this.$message({
            message:res.data.message,
            type: 'error'
          });
        }
      })
      return flag
    },
    submitForm(){
      if(this.isClick){
        return
      }
      this.isClick=true
      if(this.title=="新增用户" && this.checkName()==false){
        this.$message({
          message:"该登录名已存在！",
          type: 'error'
        });
        this.isClick=false
        return
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          var  newForm = {}
          for(var item in this.form){
            newForm[item] = this.form[item]
          }
          newForm.userId = this.user.id;
          newForm.comId = this.user.customerId
          newForm.roleIds = [this.form.roleIds]
          var url = ""
          if(this.nowInfoId!=""){//编辑
            delete newForm.pwd
            newForm.salesmanId = this.nowInfoId;
            url = "/api/ucenter/pur/staff/put"
          }else{//新增
            url = "/api/ucenter/pur/staff/add"
          }
          this.$http.post(url,newForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "保存成功",
                type: 'success'
              });
              this.open = false
              this.index(this.page)
            } else {
              this.isClick = false
              this.$message.warning(res.data.message)
            }
          })
          
        }else{
          this.isClick = false
        }
      })
    },
    
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    cancelPwd(){
      this.pwdOpen = false
      this.formPwd = {
        pwd:""
      }
    },
    findRole(){
      this.$http.get('/api/ucenter/pur/roles').then((res) => {
        if(res.data.success){
          this.roleOptions = res.data.data
        }
      })
    },
    // 表单重置
    reset() {
      this.form = {
        name: '',
        roleIds: "",
        mobile: '',
        email: '',
        loginName: '',
        pwd: ''
      };
      this.resetForm("form");
    },
   

    download() {
      window.location.href = `${this.$store.state.config.serverUrl}/static/doc/品种导入模板.xlsx`
    },
    searchByTag() {
      this.search.glid = this.value
      this.index(1)
    },
    success(e) {
      this.$message({
        type: 'success',
        message: e.message
      });
    },
    changeRole(){
      this.$forceUpdate()
    },
    async go(item) {
      this.isClick = false
      this.open=true
      var _this = this
      this.nowInfoId = item.userId
      this.$nextTick(e =>{
        this.$refs['form'].resetFields()
      })

      this.title = "修改用户"
      
      var params = {
        userId: this.user.id,
        comId:this.user.customerId,
        sid:item.userId,
      }
      this.findRole()
      this.$http.get('/api/ucenter/pur/staff/byId',{params:params}).then((res) => {
        if(res.data.success){
            if(res.data.data.roleList!=""){
              _this.form = {
                name: item.name,
                mobile: item.mobile,
                email: item.email,
                loginName: item.loginName,
                pwd: "123456",
                roleIds:res.data.data.roleList[0].roleId,
                releaseFlag:item.releaseFlag
              };
              _this.$forceUpdate()
            }
        }
      })
    },
    async del(id,loginName) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          userId: this.user.id,
          comId:this.user.customerId,
          salesmanId:id,
          loginName:loginName
        }
        this.$http.post('/api/ucenter/pur/staff/del',params).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.index(this.page)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    updatePrice(id, price) {
      this.$http.get('/api/ucenter/updatePrice', { params: { id, price } }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
        }
      });
    },
    index(page) {
      this.page = page
      var params = {
        userId: this.user.id,
        page: page,
        comId:this.user.customerId,
        pageSize: 10
      }
      if(this.search.name!=""){
        params.search = this.search
      }
      this.$http.get('api/ucenter/pur/staff/list', {
        params: params
      }).then((res) => {
        res.data.data = res.data.data ? res.data.data : []
        this.goods = res.data.data
        this.total = res.data.total
      })
    },
    cateIndex() {
      this.$http.get('/api/category').then((res) => {
        this.cates = res.data.data
      })
    },
    brandIndex() {
      this.$http.get('/api/brand').then((res) => {
        this.brands = res.data.data
      })
    },
    presclassIndex() {
      this.$http.get('/api/chuffl').then((res) => {
        this.presclass = res.data.data
      })
    },
    resetForm(form) {
      this.search.name = ""
      this.index(1)
    },
    handlEdit(id,loginName,name) {
       this.nowData.salesmanId = id
       this.nowData.loginName = loginName
       this.setPwdTitle = "重置"+name+"密码"
       this.pwdOpen =  true
    },
    handleSelectionChange(val) {
      this.selectedGoods = val
    },
    uploadImage(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post('/api/fileUpload', formData).then((res) => {
        if (res.data.success) {
          this.form.image.push(res.data.message)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },

 
  }
}



// WEBPACK FOOTER //
// ./src/views/user/userManager/userManager.js